import { useEffect, useState } from 'react';
import { getBotInfo } from '@/lib/api-client/bot';
import type { BotInfo } from '@/lib/api-client/bot';
import { ApiError } from '@/lib/api-client/client';

type BotInfoState =
  | { status: 'loading' }
  | { status: 'success'; data: BotInfo }
  | { status: 'error'; error: ApiError };

/** Same plain useState/useEffect pattern as lib/hooks/useHealth.ts — see that file's comment for why this doesn't use React Query yet. */
export function useBotInfo(): BotInfoState {
  const [state, setState] = useState<BotInfoState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getBotInfo()
      .then((data) => {
        if (!cancelled) setState({ status: 'success', data });
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        const apiError = error instanceof ApiError ? error : new ApiError('NETWORK_ERROR', 'Unexpected error.');
        setState({ status: 'error', error: apiError });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
